<script setup>
const openCookieSettings = () => {
    if (window.CCM && typeof window.CCM.openWidget === 'function') {
        window.CCM.openWidget();
    } else {
        console.warn('CCM19 ist nicht verfügbar.');
    }
};
</script>

<template>
    <button
        class="mt-4 px-6 py-2 border bg-blue text-white font-semibold rounded-xl shadow-xl hover:bg-blue/70 hover:text-white transition duration-300"
        @click="openCookieSettings"
    >
        {{ $t('cookie_settings') }}
    </button>
</template>
